import { render, staticRenderFns } from "./InquiryOrderCharts.vue?vue&type=template&id=2b17c6a8&scoped=true&"
import script from "./InquiryOrderCharts.vue?vue&type=script&lang=js&"
export * from "./InquiryOrderCharts.vue?vue&type=script&lang=js&"
import style0 from "./InquiryOrderCharts.vue?vue&type=style&index=0&id=2b17c6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17c6a8",
  null
  
)

export default component.exports